import { PackageX } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import useQuoteProductStatus from '@/hooks/useQuoteProductStatus';

/**
 * Houdt productstatussen bij voor de waarschuwingen per offerteregel.
 * Alleen niet meer beschikbare producten krijgen hier een algemene melding.
 */
export function QuoteProductNotice({ quoteId }: { quoteId: string }) {
  const { unavailable } = useQuoteProductStatus(quoteId);

  if (!unavailable.length) return null;

  return (
    <div className="space-y-2 px-4 pt-3">
      {unavailable.length > 0 && (
        <Alert variant="destructive">
          <PackageX className="h-4 w-4" />
          <AlertDescription>
            <strong>
              {unavailable.length} regel{unavailable.length === 1 ? '' : 's'} verwijst naar een
              product dat niet meer verkocht wordt.
            </strong>{' '}
            De regel blijft staan en telt gewoon mee — dit is alleen een waarschuwing.{' '}
            {unavailable
              .slice(0, 5)
              .map(
                (status) =>
                  `${status.productName} (${status.productArchived ? 'gearchiveerd' : 'uitgeschakeld'})`
              )
              .join(', ')}
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}

export default QuoteProductNotice;
